// extracted by mini-css-extract-plugin
export var container = "_m4-0";
export var dotAnimation = "_m4-2";
export var dotsLoading = "_m4-1";